export default {
  weatherReport: {
    title: "Météo",
    labels: {
      forecastUnavailable: "Prévisions indisponibles",
      unavailableDescription: "Les prévisions météo ne sont pas disponibles pour ce match.",
      unavailableValue: "S.O.",
    },
    empty: {
      title: "Aucun rapport météo disponible",
    },
  },
};
